<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="견적서 조회"
      desc="전체 견적서를 확인할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1800"
                 nextPageName="nopage"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="estimate_content" slot-scope="props" style="width: 120px; margin: auto;">
        <div @click.stop.prevent="clickEst(props.item)" style="cursor: pointer">
          <i class="material-icons">library_books</i>
        </div>
      </div>

      <div slot="response_sheet" slot-scope="props" style="width: 120px; margin: auto;">
        <div v-for="(item,idx) in props.item.price_info" :key="'item-'+idx">
          <span>{{item.note }}: </span><span>{{item.price | currency}}</span>
        </div>
      </div>

      <div slot="price" slot-scope="props">
        {{ props.item.price | currency }}
      </div>

      <div slot="response_status" slot-scope="props" style="width: 120px; margin: auto;">
        <div v-if="props.item.status=== 0">유저 확인 전</div>
        <div v-if="props.item.status=== 1">유저 확인</div>
        <div v-if="props.item.status=== 2">주문요청 완료</div>
        <div v-if="props.item.status=== 3">주문승인 완료</div>
        <div v-if="props.item.status=== 5">주문확정</div>
        <div class="text-danger" v-if="props.item.status=== 101">주문 거절</div>
        <div class="text-danger" v-if="props.item.status=== 102">주문 취소</div>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'ResponseAll',
    mixins: [
      ListMixin
    ],

    data () {
      return {
        selectedItem: undefined
      }
    },

    created () {
      this.init();
    },

    methods: {
      init() {
        this.initializing('response_all', 'estimate/bid');
      },
      getDataFromServer() {
        this.getData();
      },
      /*getData() {
        let url = '';
        if ( this.$store.getters.mode === 'admin' ){
          url = 'admin/estimate/bid';
        }
        else {
          url = 'partner/'+ this.$store.getters.partner.partner_id + '/estimate/bid';
        }

        this.$axios.get(url, {
          params: this.filtered
        })
        .then(res => {
          if(res.status===200) {
            this.tableItems = res.data.data;
            this.filtered.page_length = res.data.page_length;
            this.filtered.cur_page = res.data.cur_page;
            this.pageCount = res.data.total_page;
            this.allCount = res.data.total_count;
            this.filteredCount = res.data.count;
          }
        });
      },*/

      // 견적요청서 보기
      clickEst(item) {
        this.$axios.get(this.getUrl('estimate/request/'+item.request))
        .then(res=>{
          if(res.status===200){
            this.selectedItem = res.data;

            let value = {
              selectedItem: this.selectedItem
            }
            this.$store.commit('openModal', {type:'modal-order-content', value: value});
          }
        })
      },
      clickPartner(item, kind) {
        if(kind === 'update') {
          this.$router.push('/office/admin/partnerreg?id='+item.id);
        }else if(kind === 'delete') {
          this.modalPartner = item.id;
          this.$refs.deleteModal.open();
        }
      },

      delPartner() {
        this.$axios.post('del_partner?id='+this.modalPartner)
          .then(res => {
            if(res.data.result==='ok')
              this.toast('파트너가 삭제되었습니다.');
          });
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  .tr-whole-border th
    padding 12px 6px

  .many-field-tr td
    padding 6px

  .progress-btn
    border-radius 3px
    display inline-block
    width 100px
    padding 6px 0
    margin 2px
    font-weight bold
    font-size .8rem
  .btn-order-confirm
    background-color $primary
    color #fff
  .btn-order-not-confirm
    background-color #ffb100
    color #fff

  .bid-state
    margin 2px 0
    color #fff
    border-radius 3px
    display inline-block
    width 76px
    padding 4px

  .bid-state-ing
    background-color #1c7cd5
  .bid-state-ok
    background-color #5cb85c
  .bid-state-no
    background-color #f0ad4e

  .q-title
    font-size 0.9rem
    color $primary
    margin-top 20px
    margin-bottom 4px

  .est-title
    padding 20px
    font-size 1.2rem
    border-bottom 1px solid $primary

  .est-table
    padding 20px
    max-height 80vh

  .est-table table
    width 100%

  .est-table table
  .est-table th
  .est-table td
    border 0
    padding 4px 0
    text-align center

  .modal-title
    margin 20px 0 8px 0
    color #064160
    font-size 0.9rem
    font-weight bold

  .modal-desc
    padding 20px
    background-color #eee

  .td-est:hover
    background-color #eeeeee
    cursor pointer

  .lp-btn-bid
    cursor pointer
    border-radius 3px
    color white
    padding 4px 6px
    font-size 0.8rem
    width 74px
    margin auto
    margin-top 4px
    background-color $primary

  .btn-add
    width 24px
    height 24px
    line-height 23px
    text-align center
    font-size 1rem
    color white
    background-color $primary
    border-radius 50%

  .lp-custom-modal-btns
    padding 20px

  .btn-close
    width 45px
    color #777
    text-align center
    margin auto 0

  .lp-flex
    display flex
    flex-wrap wrap

  .lp-content textarea
  .lp-content input
    width unset
    border 1px solid #ddd
    border-radius 3px
    padding 8px 10px
    font-size 0.9rem

  .lp-content textarea
    width 100%

  .modal-step
    padding 4px
    margin-top 12px

</style>
